import Bugsnag from '@bugsnag/js'

const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY

// Only initialize if API key is configured
if (apiKey && apiKey !== 'your_api_key_here') {
    Bugsnag.start({
        apiKey: apiKey,
        appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
        // VITE_APP_ENV mirrors APP_ENV, so a bundle built on a developer
        // machine is stamped 'local'. Vite's own MODE is always 'production'
        // for anything built with `npm run build`, which used to make local
        // builds indistinguishable from the real deployment in Bugsnag.
        releaseStage: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development',
        enabledReleaseStages: ['production', 'staging'],

        // Collect breadcrumbs for better debugging
        enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
        maxBreadcrumbs: 40,

        // Add metadata before sending
        onError: function (event) {
            // Discard "Failed to fetch" noise from blocked third-party
            // analytics/tracking beacons. These are caused by ad/tracker
            // blockers on the visitor's device, not by our app. Covers
            // Bugsnag's own fetch auto-instrumentation as well as the wrapper
            // in app.js.
            const blockedHosts = [
                'google-analytics.com',
                'analytics.google.com',
                'googletagmanager.com',
                'google.com/g/collect',
                'doubleclick.net',
                'facebook.com/tr',
            ]
            const reqUrl = (event.request && event.request.url) || ''
            const fetchMeta = event.getMetadata && event.getMetadata('fetch')
            const metaUrl = (fetchMeta && fetchMeta.url) || ''
            if (blockedHosts.some(host => reqUrl.includes(host) || metaUrl.includes(host))) {
                return false
            }

            // Add current URL and referrer
            event.addMetadata('page', {
                url: window.location.href,
                referrer: document.referrer,
                title: document.title,
            })

            // Add browser info
            event.addMetadata('browser', {
                userAgent: navigator.userAgent,
                language: navigator.language,
                cookieEnabled: navigator.cookieEnabled,
                onLine: navigator.onLine,
                screenWidth: window.screen.width,
                screenHeight: window.screen.height,
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight,
            })

            // Add performance timing if available
            if (window.performance && window.performance.timing) {
                const timing = window.performance.timing
                event.addMetadata('performance', {
                    pageLoadTime: timing.loadEventEnd - timing.navigationStart,
                    domReady: timing.domContentLoadedEventEnd - timing.navigationStart,
                })
            }

            // Add user context from Laravel if available
            if (window.Laravel && window.Laravel.user) {
                event.setUser(
                    window.Laravel.user.id,
                    window.Laravel.user.email,
                    window.Laravel.user.name
                )
            }

            return true
        },

        // Filter sensitive data
        redactedKeys: [
            'password',
            'token',
            'secret',
            'api_key',
            'authorization',
            'credit_card',
            'card_number',
            'cvv',
            'stripe',
        ],
    })

    // Leave a breadcrumb on page load
    Bugsnag.leaveBreadcrumb('Page loaded', {
        url: window.location.href,
        referrer: document.referrer,
    }, 'navigation')
} else {
    console.warn('Bugsnag: API key not configured, error tracking disabled')
}

export default Bugsnag
